// import { fleetrifyIcons } from "../assets/icons/icons";
import assets from "../assets/png";

import { Staff as BaseStaff } from "../components/Table/StaffTable";


export interface Branch {
  id: number;
  branch: string;
  manager: string;
  activeOrders: number;
  location: string;
  status: "Active" | "In-active";
  time: string;
}

export type StaffWithProfile = BaseStaff & {
  firstName: string;
  lastName: string;
  otherNames: string;
  dateOfBirth: string;
  assignedVehicle: string;
  totalTrips: number;
  dateOfResumption: string;
  employmentTenure: string;
  totalHoursActive: number;
  completedTrips: number;
  cancelledTrips: number;
  customerRating: string;
};



export interface Data {
  id: number;
  calories: number;
  carbs: number;
  fat: number;
  name: string;
  protein: number;
}

export interface TabItem {
  label: string;
  value: string;
}


export interface Plan {
  id: number;
  name: string;
  features: string[];
  limits: string[];
  status: string;
}

export interface BillingInfo {
  id: number;
  nextBillingDate: string;
  billingMethod: string;
  paymentMethod: string;
}

export interface BillingHistory {
  id: number;
  date: string;
  invoice: string;
  plan: string;
  amount: string;
  status: string;
}

export interface Subscription {
  plan: Plan;
  billingInfo: BillingInfo;
  billingHistory: BillingHistory[];
}


export interface HeadCell {
  disablePadding: boolean;
  //   id: keyof Data;
  id: any;
  label: string;
  numeric: boolean;
}

export const headCells: readonly HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Dessert (100g serving)",
  },
  {
    id: "calories",
    numeric: true,
    disablePadding: false,
    label: "Calories",
  },
  {
    id: "fat",
    numeric: true,
    disablePadding: false,
    label: "Fat (g)",
  },
  {
    id: "carbs",
    numeric: true,
    disablePadding: false,
    label: "Carbs (g)",
  },
  {
    id: "protein",
    numeric: true,
    disablePadding: false,
    label: "Protein (g)",
  },
];

export const dashboardSubscriptionHeadCell = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "#ID",
  },
  {
    id: "name_of_company",
    numeric: false,
    disablePadding: false,
    label: "Name of Company",
  },
  {
    id: "plan",
    numeric: false,
    disablePadding: false,
    label: "Plan",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
];

export const dashboardSubscriptionData = [
  {
    id: 53767,
    name: "Dom Enterprise",
    plan: "Premium",
    status: "Active",
    date: "March 15, 2025",
  },
  {
    id: 53767,
    name: "Peniel Travels",
    plan: "Basic",
    status: "Inactive",
    date: "August 12, 2025",
  },
  {
    id: 53767,
    name: "Charly & Sons",
    plan: "Standard",
    status: "Active",
    date: "March 15, 2025",
  },
  {
    id: 53767,
    name: "Peniel Travels",
    plan: "Basic",
    status: "Inactive",
    date: "March 15, 2025",
  },
];

export const driversOverviewDetails = [
  {
    driverName: "Hassan Lamidi",
    driverStatus: "active",
    dateOnboarded: "Oct 12, 2024",
  },
  {
    driverName: "Stephanie Hassan",
    driverStatus: "active",
    dateOnboarded: "Oct 12, 2024",
  },
  {
    driverName: "Kehinde Saheed",
    driverStatus: "active",
    dateOnboarded: "Oct 12, 2024",
  },
  {
    driverName: "Charles Abochi",
    driverStatus: "inactive",
    dateOnboarded: "Oct 12, 2024",
  },
  {
    driverName: "Salt Abochi",
    driverStatus: "inactive",
    dateOnboarded: "Oct 12, 2024",
  },
  {
    driverName: "Prayer Chidiebere",
    driverStatus: "inactive",
    dateOnboarded: "Oct 12, 2024",
  },
];

export const statusOption = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];

export const inviteStatusOption = [
  {
    label: "Pending",
    value: "pending",
  },

  {
    label: "Rejected",
    value: "rejected",
  },
];
export const planOption = [
  {
    label: "Enterpise",
    value: "enterprise",
  },
  {
    label: "Premium",
    value: "premium",
  },
  {
    label: "Free",
    value: "free",
  },
];

export const analyticsMetrics = {
  metrics: [
    {
      title: "Total Revenue",
      value: "$1.2M",
      change: 20,
      isIncrease: true,
    },
    {
      title: "Total Expenses",
      value: "$500K",
      change: 40,
      isIncrease: false,
    },
    {
      title: "Profit/Loss",
      value: "$700K",
      change: 20,
      isIncrease: true,
    },
    {
      title: "Pending Invoices",
      value: "$100K",
      change: 20,
      isIncrease: false,
    },
  ],
};

export const ordersViewData = {
  metrics: [
    {
      title: "Total Orders",
      value: "8000",
      change: 20,
      isIncrease: true,
    },
    {
      title: "Ongoing Orders",
      value: "4050",
      change: 20,
      isIncrease: true,
    },
  ],
};

interface UsersViewDataParams {
  totalUserValue?: string | number;
  totalActiveUser?: string | number;
  totalInactiveUser?: string | number;
}

export const getUsersViewData = ({
  totalUserValue = "N/A",
  totalActiveUser = "N/A",
  totalInactiveUser = "N/A",
}: UsersViewDataParams) => ({
  metrics: [
    {
      title: "Total Users",
      value: totalUserValue,
    },
    {
      title: "Active Users",
      value: totalActiveUser,
    },
    {
      title: "Inactive Users",
      value: totalInactiveUser,
    },
  ],
});

interface IniteViewDataParams {
  totalInvitesValue?: string | number;
  pendingInvitesValue?: string | number;
  rejectedInvitesValue?: string | number;
}
export const getInvitesViewData = ({
  totalInvitesValue = "N/A",
  pendingInvitesValue = "N/A",
  rejectedInvitesValue = "N/A",
}: IniteViewDataParams) => ({
  metrics: [
    {
      title: "Total Invites",
      value: totalInvitesValue,
    },
    {
      title: "Pending Invites",
      value: pendingInvitesValue,
    },
    {
      title: "Rejected Invites",
      value: rejectedInvitesValue,
    },
  ],
});

export const companyViewData = {
  metrics: [
    {
      title: "Total Companies",
      value: "95",
      change: 20,
      isIncrease: true,
    },
    {
      title: "Inactive Companies",
      value: "70",
      change: 40,
      isIncrease: false,
    },
    {
      title: "Active Companies",
      value: "25",
      change: 20,
      isIncrease: false,
    },
  ],
};

export const companyDetailsData = {
  metrics: [
    {
      title: "Total Users",
      value: "120",
      change: 20,
      isIncrease: true,
    },
    {
      title: "Branches",
      value: "3",
      change: 33,
      isIncrease: true,
    },
    {
      title: "Active Branches",
      value: "2",
      change: 33.3,
      isIncrease: false,
    },
  ],
};

export const companyDetails = {
  about: "Peniel Salt Dominic is a Lorem Ipsum",
  address: "18, Admiralty Way, Lekki Phase 1, Lekki",
  email: "Peniel.Donn@gmail.com",
  phone: "+234 806 568 2569",
  location: "Lagos",
  employees: 120,
  branches: 3,
  joined: "April 7th, 2024",
  userId: "#53767",
  vehicles: ["Van", "Bus", "Bike"],
  services: ["Local Dispatch", "Interstate delivery", "Local relocation"],
  operationDays: "Mondays - Saturdays",
  operationHours: "08:00 - 20:00",
};

export const sampleData = [
  { name: "Jan", value: 40 },
  { name: "Week 2", value: 60 },
  { name: "Week 3", value: 45 },
  { name: "Feb", value: 100 },
  { name: "Week 2", value: 55 },
  { name: "Week 3", value: 70 },
  { name: "Mar", value: 65 },
  { name: "Week 2", value: 80 },
  { name: "Week 3", value: 50 },
  { name: "Apr", value: 30 },
  { name: "Week 2", value: 55 },
  { name: "Week 3", value: 35 },
  { name: "May", value: 75 },
  { name: "Week 2", value: 60 },
  { name: "Week 3", value: 65 },
  { name: "June", value: 70 },
];

// export const overviewData = [
//   { name: "Basic", value: 62 },
//   { name: "Standard", value: 92 },
//   { name: "Enterprise", value: 128 },
//   { name: "Premium", value: 78 },
// ];
export const overviewData = [
  { name: "Jan", mainBranch: 400, annexBranch: 240 },
  { name: "Feb", mainBranch: 300, annexBranch: 139 },
  { name: "Mar", mainBranch: 200, annexBranch: 980 },
  { name: "Apr", mainBranch: 278, annexBranch: 390 },
  { name: "May", mainBranch: 189, annexBranch: 480 },
];
export const rolesOption = [
  {
    label: "Viewer",
    value: "viewer",
  },
  {
    label: "Editor",
    value: "editor",
  },
  {
    label: "Content Manager",
    value: "content manager",
  },
  {
    label: "Moderator",
    value: "moderator",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Project Manager",
    value: "project manager",
  },
  {
    label: "Customers",
    value: "customers",
  },
  {
    label: "Product Manager",
    value: "product manager",
  },
  {
    label: "Account Manager",
    value: "account manager",
  },
  {
    label: "Super Admin",
    value: "super admin",
  },
  {
    label: "Creator Admin",
    value: "creator admin",
  },
  {
    label: "Support",
    value: "support",
  },
  {
    label: "Sales Manager",
    value: "sales manager",
  },
  {
    label: "HR Manager",
    value: "hr manager",
  },
  {
    label: "Marketing Manager",
    value: "marketing manager",
  },
];

export const invoiceSummary = [
  { label: "Month", value: "March" },
  { label: "Company", value: "4 Selected" },
  { label: "Payment completed", value: 4 },
  { label: "Printed", value: "Mar 26, 2025" },
];

export const expiryDurations = [
  {
    label: "Three months",
    value: "Three months",
  },
  {
    label: "Five months",
    value: "five months",
  },
  {
    label: "One year",
    value: "one year",
  },
];

export const usersOptions = [
  {
    label: "Amina Yusuf",
    value: "amina_yusuf",
  },
  {
    label: "Kwame Mensah",
    value: "kwame_mensah",
  },
  {
    label: "Chinelo Okeke",
    value: "chinelo_okeke",
  },
  {
    label: "Thabo Mokoena",
    value: "thabo_mokoena",
  },
  {
    label: "Fatoumata Diallo",
    value: "fatoumata_diallo",
  },
  {
    label: "Abdulrahman Bello",
    value: "abdulrahman_bello",
  },
  {
    label: "Zanele Dlamini",
    value: "zanele_dlamini",
  },
  {
    label: "Ibrahim Njoroge",
    value: "ibrahim_njoroge",
  },
  {
    label: "Efe Ighodalo",
    value: "efe_ighodalo",
  },
  {
    label: "Naledi Kgosi",
    value: "naledi_kgosi",
  },
];

interface Tab {
  label: string;
  value: string;
}

export const user_tabs: Tab[] = [
  { label: "Profile", value: "profile" },
  { label: "Activity", value: "activity" },
];
export const invite_tabs: Tab[] = [{ label: "Profile", value: "profile" }];

export const nofity_tabs: Tab[] = [
  { label: "Recent", value: "recent" },
  { label: "All", value: "all" },
];

export const dummyNotifications = [
  {
    id: "1",
    avatarSrc: assets.Wrangler,
    sender: "Wrangler",
    message: "You have a new message",
    timestamp: "Today at 11:20 AM",
    isNew: true,
  },
  {
    id: "2",
    avatarText: "K",
    avatarSrc: assets.Kristin,
    sender: "K",
    message: "You have a new message",
    timestamp: "Today at 11:00 AM",
    isNew: true,
  },
  {
    id: "3",
    avatarText: "S",
    avatarSrc: assets.Rosy,
    sender: "S",
    message: "You have a new message",
    timestamp: "08 hours ago",
    isNew: false,
  },
  {
    id: "4",
    avatarText: "PD",
    avatarSrc: assets.Donn,
    sender: "Peniel",
    message: "requested a profile update",
    timestamp: "14 hours ago",
    isNew: false,
  },
  {
    id: "5",
    avatarText: "JT",
    sender: "Jonathan",

    message: "have a new message",
    timestamp: "21 hours ago",
    isNew: false,
  },
  {
    id: "6",
    avatarSrc: assets.Kristin,
    sender: "You",
    message: "You have a new message",
    timestamp: "24 hours ago",
    isNew: false,
  },
  {
    id: "7",
    avatarText: "HG",
    sender: "Harrison",
    message: "sent a message",
    timestamp: "01 day ago",
    isNew: false,
  },
];

export type Permission = {
  label: string;
  general: boolean;
  limited: boolean;
};

export const initialPermissions: Permission[] = [
  {
    label: "User can deactivate Admin users & company accounts.",
    general: true,
    limited: false,
  },
  {
    label: "User can reactivate Admin users & company accounts.",
    general: true,
    limited: false,
  },
  {
    label: "User can delete Admin users",
    general: true,
    limited: false,
  },
  {
    label: "User can check audit logs",
    general: true,
    limited: true,
  },
  {
    label: "User can give support to companies",
    general: true,
    limited: false,
  },
  {
    label: "Access to check orders",
    general: true,
    limited: true,
  },
  {
    label: "Access to check reports",
    general: true,
    limited: false,
  },
];

export type RolePermission = {
  label: string;
  checked: boolean;
};

export const defaultPermissions: RolePermission[] = [
  {
    label: "User can deactivate Admin users & company accounts.",
    checked: false,
  },
  {
    label: "User can reactivate Admin users & company accounts.",
    checked: false,
  },
  { label: "User can delete Admin users", checked: false },
  { label: "User can check audit logs", checked: false },
  { label: "User can give support to companies", checked: true },
  { label: "Access to check orders", checked: true },
  { label: "Access to check reports", checked: true },
];

export const userTableData = [
  {
    id: 1,
    img: null,
    name: "Jackson Graham",
    email: "jackson.graham@example.com",
    role: "Super admin",
    status: "Active",
    date: "March 15, 2025",
  },
  {
    id: 2,
    img: null,
    name: "Michael Mitc",
    email: "michael.mitc@example.com",
    role: "Admin",
    status: "Inactive",
    date: "August 12, 2025",
  },
  {
    id: 3,
    img: null,
    name: "Debra Holt",
    email: "debra.holt@example.com",
    role: "User",
    status: "Active",
    date: "March 15, 2025",
  },
  {
    id: 4,
    img: null,
    name: "Bill Sanders",
    email: "bill.sanders@example.com",
    role: "Admin",
    status: "Inactive",
    date: "March 15, 2025",
  },
  {
    id: 5,
    img: null,
    name: "Nathan Roberts",
    email: "nathan.roberts@example.com",
    role: "User",
    status: "Active",
    date: "March 15, 2025",
  },
  {
    id: 6,
    img: null,
    name: "Deanna Curtis",
    email: "deanna.c@example.com",
    role: "Admin",
    status: "Inactive",
    date: "March 15, 2025",
  },
  {
    id: 7,
    img: null,
    name: "Nevaeh Simmons",
    email: "nevaeh.simmons@example.com",
    role: "User",
    status: "Inactive",
    date: "March 15, 2025",
  },
  {
    id: 8,
    img: null,
    name: "Sara Cruz",
    email: "sara.cruz@example.com",
    role: "User",
    status: "Active",
    date: "March 09, 2025",
  },
  {
    id: 9,
    img: null,
    name: "Guy Hawkins",
    email: "felicia.reid@example.com",
    role: "Admin",
    status: "Inactive",
    date: "August 12, 2025",
  },
  {
    id: 10,
    img: null,
    name: "Wade Warren",
    email: "georgia.young@example.com",
    role: "User",
    status: "Active",
    date: "March 15, 2025",
  },
];

export const backOfficeRoles = [
  {
    name: "Super Administration",
    description: "Full control over the system.",
  },
  { name: "Administration", description: "Manage daily admin tasks." },
  {
    name: "Customer Care",
    description: "Handle customer support and queries.",
  },
];

export const rejectionReasons = [
  "Incorrect information",
  "Spam or abuse",
  "No longer interested",
  "Others",
];

export const passwordChecks = [
  (pw: string) => pw.length >= 8,
  (pw: string) => /[A-Z]/.test(pw),
  (pw: string) => /[a-z]/.test(pw),
  (pw: string) => /[0-9]/.test(pw),
  (pw: string) => /[!@#$%^&*]/.test(pw),
];

export interface ActivityLogItem {
  id: number;
  activity: string;
  created_at: string;
}

export const sampleLogs: ActivityLogItem[] = [
  { id: 1, activity: "User logged in", created_at: "2025-06-01T09:15:00Z" },
  {
    id: 2,
    activity: "Updated profile details",
    created_at: "2025-06-01T11:20:00Z",
  },
  { id: 3, activity: "Changed password", created_at: "2025-06-02T08:45:00Z" },
  { id: 4, activity: "Logged out", created_at: "2025-06-02T10:30:00Z" },
];

export const DEACTIVATION_REASONS = [
  "User no longer with the company",
  "Suspicious or fraudulent activity",
  "Repeated policy violations",
  "Request from user",
  "Others",
];

const generateRandomId = () => Math.floor(Math.random() * 1000000);
export const auditLogData = [
  {
    id: generateRandomId(),
    ipAddress: "#53767",
    user: "Dom Enterprise",
    role: "Admin",
    activity: "Delete",
    module: "Users",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53768",
    user: "Peniel Travels",
    role: "Manager",
    activity: "Invite user",
    module: "Users",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53769",
    user: "Charly & Sons",
    role: "Admin",
    activity: "Update",
    module: "Report",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53770",
    user: "Peniel Travels",
    role: "Admin",
    activity: "Delete",
    module: "Company",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53771",
    user: "Dom",
    role: "Super-admin",
    activity: "Accept Onboarding",
    module: "Settings",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53772",
    user: "Charles Angels",
    role: "Admin",
    activity: "Decline Onboarding",
    module: "Settings",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53773",
    user: "Odogwu Paranran",
    role: "Manager",
    activity: "Update",
    module: "Users",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53774",
    user: "NSPPD Movements",
    role: "Admin",
    activity: "Invite user",
    module: "Users",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53775",
    user: "Peniel Travels",
    role: "Admin",
    activity: "Delete",
    module: "Customer",
    timestamp: "2025-05-04 14:23",
  },
  {
    id: generateRandomId(),
    ipAddress: "#53776",
    user: "Chisco Logistics",
    role: "Admin",
    activity: "Delete",
    module: "Users",
    timestamp: "2025-05-04 14:23",
  },
];

// dummy new auditlog generated data stef
const generateRandomIds = () => Math.floor(Math.random() * 1000000);
export const mockAuditLogs = [
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:00:00",
    user: "John Doe",
    module: "Login",
    "device type": "MacBook",
    event: "User logged in",
    description: "User updated the Driver assignment of Vehicle ID: FLT-2024-012. Previous Driver: Ayodele Olawale. New Driver: Danjuma Ibrahim",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-08-13 08:05:00",
    user: "Stephanie Alor",
    module: "Order",
    "device type": "HP Pavilion",
    event: "Login",
    description: "User logged into the Order Management portal.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-08-25 06:05:00",
    user: "Stephanie Walson",
    module: "Fleet Management",
    "device type": "Dell",
    event: "Create",
    description: "New fleet record created for vehicle ID FLT-2456.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:00:00",
    user: "Loveth Barry",
    module: "Staff Management",
    "device type": "MacBook",
    event: "Update",
    description: "Updated staff profile for ID STF-1032.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:05:00",
    user: "Angela Smith",
    module: "Report",
    "device type": "iPhone 13",
    event: "Delete",
    description: "Deleted monthly sales report for June 2025.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:10:00",
    user: "Michael Johnson",
    module: "Dashboard",
    "device type": "iPhone",
    event: "Retrieve",
    description: "Retrieved analytics data for Q2 2025.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:15:00",
    user: "Emily Davis",
    module: "Report",
    "device type": "Infinix",
    event: "Login",
    description: "User logged into reporting dashboard.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:20:00",
    user: "Chris Brown",
    module: "Reports",
    "device type": "MacBook",
    event: "Downloaded report",
    description: "Downloaded annual performance report for 2025.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:25:00",
    user: "Sarah Miller",
    module: "Fleet Management",
    "device type": "Samsung",
    event: "Delete",
    description: "Removed vehicle ID FLT-1987 from fleet records.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:30:00",
    user: "David Wilson",
    module: "Dahboard",
    "device type": "iPad",
    event: "Changed password",
    description: "User changed account password successfully.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:35:00",
    user: "Lino Brown",
    module: "Login",
    "device type": "MacBook",
    event: "Failed login attempt",
    description: "Failed login attempt detected from IP 192.168.0.2.",
    status: "Failed",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:40:00",
    user: "James Aurthur",
    module: "Dashboard",
    "device type": "Windows PC",
    event: "Viewed analytics",
    description: "Viewed website traffic analytics for August 2025.",
    status: "Success",
  },
  {
    id: generateRandomIds(),
    timestamp: "2025-06-21 12:45:00",
    user: "Olivia Kim",
    module: "Report",
    "device type": "iPhone",
    event: "Monthly report",
    description: "Generated monthly report for July 2025.",
    status: "Success",
  },
];

const generateSubscriptionIds = (): number =>
  Math.floor(Math.random() * 1000000);

export const mockSubscriptions = {
  plan: {
    id: generateSubscriptionIds(),
    name: "Growth",
    features: [
      "Manage up to 5 branches",
      "Add up to 10 users",
      "Advanced Analytics and Report",
    ],
    limits: [
      "Unlimited Branches and Users",
      "Full Reporting",
      "Dedicated Support",
    ],
    status: "Active",
  },
  billingInfo: {
    id: generateSubscriptionIds(),
    nextBillingDate: "2025-09-11",
    billingMethod: "Monthly / ₦28,000",
    paymentMethod: "Visa **** 1234",
  },
  billingHistory: [
    {
      id: generateSubscriptionIds(),
      date: "2025-07-04",
      invoice: "inv_trial123",
      plan: "Trial",
      amount: "₦0.00",
      status: "No Charge",
    },
    {
      id: generateSubscriptionIds(),
      date: "2025-07-11",
      invoice: "inv456789",
      plan: "Growth",
      amount: "₦19,900.00",
      status: "Paid",
    },

    {
      id: generateSubscriptionIds(),
      date: "2024-11-11",
      invoice: "inv456797",
      plan: "Starter",
      amount: "₦4,900.00",
      status: "Paid",
    },
    {
      id: generateSubscriptionIds(),
      date: "2024-10-11",
      invoice: "inv456798",
      plan: "Starter",
      amount: "₦4,900.00",
      status: "Paid",
    },
    {
      id: generateSubscriptionIds(),
      date: "2024-09-11",
      invoice: "inv456799",
      plan: "Growth",
      amount: "₦19,900.00",
      status: "Paid",
    },
    {
      id: generateSubscriptionIds(),
      date: "2024-08-11",
      invoice: "inv456800",
      plan: "Growth",
      amount: "₦19,900.00",
      status: "Paid",
    },
  ],
};


// mock for branch
export const mockBranch: Branch[] = [
  { id: 53567, branch: "Lagos", manager: "Kehinde Adekoya", activeOrders: 210, location: "Osun", status: "Active", time: "March 15, 2025" },
  { id: 53568, branch: "Abuja", manager: "Salt Okpala", activeOrders: 145, location: "Kano", status: "In-active", time: "March 15, 2025" },
  { id: 53569, branch: "Port Harcourt", manager: "Prayer Chinosno", activeOrders: 300, location: "Rivers", status: "Active", time: "March 15, 2025" },
  { id: 53570, branch: "Enugu", manager: "Charles Okongwu", activeOrders: 120, location: "Anambra", status: "Active", time: "March 15, 2025" },
  { id: 53571, branch: "Ibadan", manager: "Stephanie Uwaje", activeOrders: 95, location: "Oyo", status: "In-active", time: "March 15, 2025" },
  { id: 53572, branch: "Kano", manager: "Hassan Alor", activeOrders: 280, location: "Kaduna", status: "Active", time: "March 15, 2025" },
  { id: 53573, branch: "Asaba", manager: "Opeyemi Abochi", activeOrders: 110, location: "Delta", status: "In-active", time: "March 15, 2025" },
  { id: 53574, branch: "Benin City", manager: "Temilouwa Dominic", activeOrders: 170, location: "Edo", status: "Active", time: "March 15, 2025" },
  { id: 53575, branch: "Uyo", manager: "Uwaje Adekoya", activeOrders: 220, location: "Akwa Ibom", status: "Active", time: "March 15, 2025" },
];


export const roles_data = [
  {
    role: "Super Administration",
    no_of_users: "1",
    date: "March 15, 2025",
  },
  {
    role: "Super Administration",
    no_of_users: "1",
    date: "March 15, 2025",
  },
  {
    role: "Super Administration",
    no_of_users: "1",
    date: "March 15, 2025",
  },
];

export interface SettingsRolePermission {
  module: string;
  title: string;
  label: string;
  checked: boolean;
}

export const defaultSettingsPermissions: SettingsRolePermission[] = [
  {
    module: "admin",
    title: "Admin Controls",
    label: "User can deactivate Admin users & company accounts.",
    checked: false,
  },
  {
    module: "admin",
    title: "Admin Controls",
    label: "User can reactivate Admin users & company accounts.",
    checked: false,
  },
  {
    module: "admin",
    title: "Admin Controls",
    label: "User can delete Admin users",
    checked: false,
  },
  {
    module: "audit",
    title: "Audit Access",
    label: "User can check audit logs",
    checked: false,
  },
  {
    module: "support",
    title: "Company Support",
    label: "User can give support to companies",
    checked: true,
  },
  {
    module: "orders",
    title: "Order Management",
    label: "Access to check orders",
    checked: true,
  },
  {
    module: "reports",
    title: "Reporting",
    label: "Access to check reports",
    checked: true,
  },
];

export interface AppNotification {
  id: string;
  avatarSrc?: string;
  avatarText?: string;
  sender: string;
  message: string;
  timestamp: string;
  isNew?: boolean;
}

export interface Conversation {
  id: string;
  name: string;
  lastMessage: string;
  lastMessageTimestamp: number;
  unreadCount: number;
  profilePic?: string;
  status?: string
}

export const chatConversations = [
  {
    id: "1",
    name: "Wrangler",
    lastMessage: "Hi Fleetify Team...",
    lastMessageTimestamp: Date.now() - 3600000,
    unreadCount: 2,
    profilePic: assets.Wrangler,
  },
  {
    id: "2",
    name: "Kristin Logistics",
    lastMessage: "MetroQuick specializes in last-mile deli...",
    lastMessageTimestamp: Date.now() - 7200000,
    unreadCount: 0,
    profilePic: assets.Kristin,
  },
  {
    id: "3",
    name: "Rosy Freight",
    lastMessage: "Hello, Rosy's Freight operates in the U.S....",
    lastMessageTimestamp: Date.now() - 54000000,
    unreadCount: 1,
    profilePic: assets.Rosy,
  },
  {
    id: "4",
    name: "Peniel & Travels",
    lastMessage: "Hi Team Fleetify, Peniel & Travels Services main...",
    lastMessageTimestamp: Date.now() - 64800000,
    unreadCount: 0,
    profilePic: assets.Peniel,
  },
  {
    id: "5",
    name: "Donn Azubuike Transit",
    lastMessage: "Hi Fleetify, Donn Azubuike Transit manages 15...",
    lastMessageTimestamp: Date.now() - 86400000,
    unreadCount: 0,
    profilePic: assets.Donn,
  }
]


export const orderSummaryHeaders = {
  field: "Field",
  value: "Value",
};

export const activityHeader = {
  field: "Date & Time",
  value: "Activity"
}

export const orderData = [
  { label: "Order ID", value: "FD-INT-DEL-1043" },
  { label: "Client Name", value: "Michael Johnson" },
  { label: "Order Date", value: "July 15, 2025" },
  { label: "Status", value: "In Transit", isStatus: true },
  { label: "Tracking ID", value: "TRK-FLEET-9831" },
  { label: "Estimated Delivery", value: "July 17, 2025" },
  { label: "Service Type", value: "Inter-State Delivery" },
];

export const activityTimelineData = [
  { label: "Jul 15, 09:00 AM", value: "Pickup confirmed in Lagos" },
  { label: "Jul 15, 10:15 AM", value: "Package scanned and loaded" },
  { label: "Jul 15, 12:30 PM", value: "Departed from warehouse" },
  { label: "Jul 16, 11:15 AM", value: "Passed checkpoint @ Lokoja" },
];

export const paymentInformation = [
  { label: "Total Cost", value: "₦42,000" },
  { label: "Payment Status", value: "Paid", isStatus: true },
  { label: "Payment Method", value: "Bank Transfer" },
  { label: "Invoice Number", value: "INV-FLEET-2025-1043" },
  { label: "Transaction ID", value: "TXN-0984432902" },
];


export const deliveryDetailsHeader = {
  field: "Field",
  value: "Value",
};

export const orderSummaryDeliveryDetails = [
  {
    label: "Pickup Location",
    value: "Lagos, Nigeria – No. 13 Marine Road",
  },
  {
    label: "Drop-off Location",
    value: "Abuja, Nigeria – No. 5 Unity Avenue",
  },
  {
    label: "Pickup Date",
    value: "July 15, 2025 @ 09:00 AM",
  },
  {
    label: "Expected Delivery",
    value: "July 17, 2025 @ 6:00 PM",
  },
  {
    label: "Distance",
    value: "~760 KM",
  },
  {
    label: "Vehicle Assigned",
    value: "Ford Cargo Van - FG0921LX",
  },
  {
    label: "Driver Assigned",
    value: "John Adewale",
  },
  {
    label: "Driver Contact",
    value: "+234 809 123 4567",
  },
];
export const packageDetails = [
  {
    label: "Package Type",
    value: "Medium Crate",
  },
  {
    label: "Package Weight",
    value: "25 kg",
  },
  {
    label: "Package Dimensions",
    value: "60cm x 40cm x 35cm"
  },
  {
    label: "Item Description",
    value: "Office Electronics (Printer, Scanner, Router)",
  },
  {
    label: "Fragile",
    value: "Yes",
  },
  {
    label: "Insured",
    value: "Yes",
  },
  {
    label: "Driver Contact",
    value: "+234 8177 1359 33",
  },
];
